import './BlogPostCard.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../../common/utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Picture } from '@dataartdev/uikit/Picture';
import { Tag } from '@dataartdev/uikit/Tag';
import { Item } from '../pages/blog_page_models';
import { User } from '@dataartdev/uikit/User';

export const cnBlogPostCard = cn('BlogPostCard');

export const BlogPostCard: React.FC<Item> = props => {
  const { type, url, string, tags, picture, speakers } = props || {};
  const generateCardLink = (url: string) => {
    if (!url) return;
    return url.includes('http') ? (
      <a href={url} className={cnBlogPostCard('Link')} />
    ) : (
      <Link to={url} className={cnBlogPostCard('Link')} />
    );
  };
  return (
    <div className={cnBlogPostCard()}>
      {url && generateCardLink(url)}
      {picture && (
        <div className={cnBlogPostCard('Picture')}>
          <Picture {...picture} />
        </div>
      )}
      <div className={cnBlogPostCard('Content')}>
        {type && (
          <Typography.Text
            size="xs"
            weight="bold"
            transform="uppercase"
            className={cnBlogPostCard('SubTitle')}
          >
            {type?.title}
          </Typography.Text>
        )}
        <div className={cnBlogPostCard('Title')}>
          {string && <Typography.Title size="sm">{string}</Typography.Title>}
          <div className={cnBlogPostCard('Speakers')}>
            {speakers &&
              speakers.length > 0 &&
              speakers.map((speaker, index) => (
                <React.Fragment key={speaker.firstName + speaker.lastName}>
                  {speaker.photo && (
                    <User
                      size="m"
                      avatarUrl={speaker.photo?.urlWebp || speaker.photo?.url}
                      style={{ zIndex: speakers.length - index }}
                    />
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
        {tags && tags?.length > 0 && (
          <div className={cnBlogPostCard('Tags')}>
            {tags.map(tag => (
              <Tag
                key={tag.id}
                mode="link"
                label={tag.title}
                className={cnBlogPostCard('Tag')}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
